import React from 'react';
import { Text } from '@chakra-ui/react';
import styled from 'styled-components';

import { PortalLink } from 'apps/client/components/PortalLink';
import Icon from 'components/Icon';
import { OpenTab } from 'libs/gutClient/electronBridge';

type RfqNameLinkProps = {
  rfq: {
    decimalId: string;
    intermediatorSession: {
      shareFile: {
        id: string;
        name: string;
      };
    };
  };
  showId: boolean;
  onClick?: () => void;
  openTab?: OpenTab;
};

export function RfqNameLink(props: RfqNameLinkProps) {
  const { rfq, showId, openTab } = props;
  let text = 'Loading...';
  if (showId) text = `R${rfq.decimalId}`;
  else {
    const { shareFile } = rfq.intermediatorSession;
    if (shareFile) {
      text = shareFile.name;
    }
  }
  return (
    <PortalLink
      name='rfq'
      params={{ rfqId: rfq.decimalId }}
      onClick={props.onClick}
      openTab={openTab}
    >
      <Text color='black' _hover={{ color: 'blue' }}>
        {text}
      </Text>
    </PortalLink>
  );
}

const ArrowButtonLinkStyled = styled.div`
  display: flex;
  justify-content: center;
`;

// should take type LinkParams

export function ArrowButtonLink({
  name,
  params,
  onClick,
  openTab,
}: {
  name: string;
  params: object;
  onClick: object;
  openTab?: OpenTab;
}) {
  return (
    <ArrowButtonLinkStyled>
      <PortalLink
        name={name}
        params={params}
        onClick={onClick}
        openTab={openTab}
      >
        <Icon name='arrow_right' />
      </PortalLink>
    </ArrowButtonLinkStyled>
  );
}
